<template lang="pug">
  .course-group-manager
    el-row(style="display:flex; justify-content: center;" type="flex" :gutter="8")
      el-col
        el-link(href="https://www.facebook.com/NiceCourseToU/" )
          el-image(src="https://upload.cc/i1/2020/09/07/NHSTyE.png" style="width: 30px; height: 30px")
      //el-col
        //el-button(icon="el-icon-s-grid" round="" size="small" @click="showCourseGroupManager")
          span.hidden-sm-and-down {{ this.$store.state.usingCourse }}
      el-col
        a-button(shape="round" size="small" @click="openShareAlert")
          a-icon(type="area-chart")
          span.hidden-sm-and-down 分享課程
      el-col
        a-button(shape="round" size="small" @click="openImportAlert")
          a-icon(type="area-chart")
          span.hidden-sm-and-down 匯入選上率
      el-col
        a-badge(dot)
          a-button(shape="round" size="small" @click="openImportSelectedAlert")
            a-icon(type="import")
            span.hidden-sm-and-down 匯入已選課
      //el-col
        a-badge(dot)
          a-button(shape="round" size="small" @click="syncSession")
            a-icon(type="sync")
            span.hidden-sm-and-down 同步
      //el-col
        a-badge(dot)
          a-button(shape="round" size="small" @click="downloadSession")
            a-icon(type="sync")
            span.hidden-sm-and-down 下載
    course-detail-drawer
    el-drawer(:visible.sync="openCourseGroup" direction="ltr" size="70%" title="選擇課程群組")
      el-table(:data="presentCourseGroup" :highlight-current-row="true" empty-text="無課程" height="600" size="mini" @row-click="clickCourseGroup")
        el-table-column(labe="選擇課程表" prop="groupKey")
      el-button.add-course-group-button(plain="" type="primary" @click="addCourseGroup")
        | + 新增課程表
</template>
<script>
import {parseCourse} from "@/courseProcessor";
import CourseDetailDrawer from "@/components/Drawer/CourseDetailDrawer";
import {Values} from "@/fuckingJSExtension";
import axios from "axios";
import {CORSproxy, syncStorageName} from "@/sessionSave";

export default {
  name: 'course-group-manager',
  components: {CourseDetailDrawer},
  methods: {
    showCourseGroupManager() {
      this.openCourseGroup = true
    },
    clickCourseGroup(courseGroup) {
      console.log("Clicked course:", courseGroup)
      this.$store.commit('switchCourseGroup', courseGroup.groupKey)
      this.openCourseGroup = false
    },
    addCourseGroup() {
      this.$prompt('請輸入新的課程表名稱', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '新增',
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '已新增課程表: ' + value
        });
        this.$store.commit('switchCourseGroup', value)
        this.openCourseGroup = false
      })
    },
    openShareAlert() {
      var link = this.$store.state.domain
      link += '?importCourseGroupName=' + this.$store.state.usingCourse + '&'
      let courseID = this.$store.state.courseGroups[this.$store.state.usingCourse].list.map((v) => `${v.acy}${v.sem}_${v.id}`)
      link += '?importCoursesID=' + courseID
      this.$prompt('複製以下連結來分享給朋友吧', '分享課程表', {
        confirmButtonText: '確定',
        inputValue: link
      })
    },
    openImportAlert() {
      var value = ''
      this.$prompt('分析課程選上機率，選通識不再眼花撩亂。\n從選課網站全選複製，然後貼在下面吧！', '匯入個人選課資訊(Beta)', {
        confirmButtonText: '確定',
        inputValue: value
      }).then(({value}) => {
        const parsedCourse = parseCourse(value)
        this.$store.commit('loadCourseExtension', parsedCourse)
        this.$message.info(`已匯入 ${Values(parsedCourse).length} 門課程的志願序機率`);
      })
    },
    openImportSelectedAlert() {
      var value = ''
      this.$prompt(`選完的課全部丟進來NiceCourseToU，哪裡衝堂一看就知道。\n複製「確認選課狀況」>「查詢選課狀況」的所有文字，貼在下面吧！\n(
          不要像作者重稻覆轍用通識衝堂計網概必修嗚嗚嗚(PД\`q。)·。`, '匯入選課系統內已選課程(Beta)', {
        confirmButtonText: '確定',
        inputValue: value
      }).then(({value}) => {
        const parsedCourse = parseCourse(value)
        console.log(parsedCourse)
        const selectedCourses = this.allSelectedCourses.map((c) => c.id)
        console.log(this.allSelectedCourses)
        for(const cid of Object.keys(parsedCourse)){
          const fullCid = `1091_${cid}`
          const course = this.allCourses[fullCid]
          if(course){
            if(selectedCourses.includes(cid)){
              console.log(`Course ${course.cname} has added and skipped`)
            }else{
              this.updateCourse(course)
              console.log(`Course ${course.cname} added`)
            }
          }
        }
        // this.$store.commit('loadCourseExtension', parsedCourse)
        this.$message.info(`已匯入 ${Values(parsedCourse).length} 門已選課程`);
      })
    },
    syncSession() {
      const state = this.$store.state
      const inboxUrl = CORSproxy + "https://docs.google.com/forms/d/e/1FAIpQLSceXYLXYAAUwu8RoLl61VcAJyCSG0MXASBNEWyx1mhBNVR3_Q/formResponse"
      var uploadingSession = {}
      for (let key of syncStorageName) {
        uploadingSession[key] = state[key]
      }
      let d = {
        'entry.118437476': JSON.stringify(uploadingSession),
        'entry.751211111': state.user.loginInfo.name
      }
      console.log(d)
      axios({method: 'get', url: inboxUrl, params: d})
          .then(
              () => this.$message.info(`已同步完成`)
          )
          .catch(
              (e) => this.$message.info(`同步失敗 ${e}`)
          )
    },
    async downloadSession(){
      const sheetId = '1Hc747yTIiMghbF4ZjHYLuQT-98NwKTvsAH6qWFt_Aew'
      const sheetTableId = '1'
      const desturl = CORSproxy + `https://spreadsheets.google.com/feeds/list/${sheetId}/${sheetTableId}/public/values?alt=json`
      let resp = await axios.get(desturl)
          .catch(function (e) {
            this.$notify({
              title: '無法讀取聊天室內容',
              message: e,
              type: 'danger'
            })
          })
      if(resp.data){
        let rawMessage = resp.data.feed.entry
        console.log(rawMessage)
      }
    }
  },
  computed: {
    openCourseGroup: {
      get() {
        return this.$store.state.user.showCoursesGroupManager;
      },
      set(newValue) {
        this.$store.state.user.showCoursesGroupManager = newValue
      }
    },
    presentCourseGroup() {
      let courseGroup = []
      courseGroup = this.$store.state.courseGroupsAvailable.map((v) => ({'groupKey': v}))
      // console.log(courseGroup)
      return courseGroup
    }
  }
}
</script>
<style>
.course-group-manager {
  /*padding: 10px;*/
}

.add-course-group-button {
  width: 100%
}
</style>
